<template>
<app-layout>
 
  
  <jet-authentication-card>

    <div class="card-body text-center">

      <img src="https://s3.eu-west-3.amazonaws.com/expopolis-ecommerce/logos/aa4079ad95d535c7ef32e895feb02647.jpeg" style="max-width:150px;" class="img-fluid img-thumbnail"/>
      <br/>
      <br/>
      <p>Click button below will redirect you to Payrecon website for authentication.</p>
      <a :href="$page.props.url" class="btn btn-primary rounded-0 hvr-float" style="background:#e8641c;border:none;">Login with Payrecon</a>

    </div>
  </jet-authentication-card>
</app-layout>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import AppLayout from '@/Layouts/AppLayout'


export default {
  components: {
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetCheckbox,
    JetLabel,
    JetValidationErrors,
    AppLayout
  },

  props: {
    "url":String
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false
      })
    }
  },

  methods: {
    submit() {
      this.form
          .transform(data => ({
            ... data,
            remember: this.form.remember ? 'on' : ''
          }))
          .post(this.route('login'), {
            onFinish: () => this.form.reset('password'),
          })
    }
  }
}
</script>
